/**
 * Connection Grid Component - renders the grid of document source connections
 */

import React from 'react';
import { Alert } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';
import { ExtendedConnectionResponse } from '../../../types/common';
import { ConnectionCard } from './ConnectionCard';

interface ConnectionGridProps {
  connections: ExtendedConnectionResponse[];
  onEdit: (connection: ExtendedConnectionResponse) => void;
  onDelete: (connection: ExtendedConnectionResponse) => void;
  onSync: (connectionId: string) => void;
  onTest: (connectionId: string) => void;
}

export const ConnectionGrid: React.FC<ConnectionGridProps> = ({
  connections,
  onEdit,
  onDelete,
  onSync,
  onTest,
}) => {
  const { t } = useTranslation();

  if (connections.length === 0) {
    return (
      <Alert severity="info" sx={{ mb: 3 }}>
        {t('documentSources.noConnections')}
      </Alert>
    );
  }

  return (
    <Grid container spacing={3}>
      {connections.map((connection) => (
        <Grid size={{ xs: 12, sm: 6, md: 4 }} key={connection.id}>
          <ConnectionCard
            connection={connection}
            onEdit={onEdit}
            onDelete={onDelete}
            onSync={onSync}
            onTest={onTest}
          />
        </Grid>
      ))}
    </Grid>
  );
};